"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a ContactCard
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A contact card
 */
function ContactCard(props) {
  var _extractedFields$Vari, _extractedFields$Link, _extractedFields$Eyeb;
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var displayVariant = (_extractedFields$Vari = extractedFields.Variant) !== null && _extractedFields$Vari !== void 0 && _extractedFields$Vari.value ? extractedFields.Variant.value : 'dark';
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)((_extractedFields$Link = extractedFields.Link) === null || _extractedFields$Link === void 0 ? void 0 : _extractedFields$Link.value);
  var CardTitle = props => {
    return (0, _titleHeadTag.headTagTitle)(props.Title, 'card-title', props.TitleSize.value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: displayVariant
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-contact mm-text-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, (_extractedFields$Eyeb = extractedFields.Eyebrow) === null || _extractedFields$Eyeb === void 0 ? void 0 : _extractedFields$Eyeb.value), /*#__PURE__*/_react.default.createElement(CardTitle, extractedFields), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, {
    className: "copy-lg"
  }, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: extractedFields.ButtonType.value,
    href: linkUrl,
    target: linkTarget,
    linkAlt: linkAlt,
    label: extractedFields.Text.value,
    icon: extractedFields.ctaIcon.value,
    iconDirection: extractedFields.ctaIconPlacement.value,
    dataId: extractedFields.ctaDataId.value
  }))))));
}
var _default = exports.default = ContactCard;